"use strict";

export default {
	created : function() {
		if(!this.currentSession.event || !this.currentSession.event.name) {
			let currEvent = localStorage.getItem("currentEvent");
			if(currEvent && currEvent.length) {
				try{
					currEvent = JSON.parse(currEvent);
					return this.$emit('newEventSelected', currEvent);
				}catch(e){console.log(e);}
			}
			if(!currEvent) return this.$router.push({name : 'newEvent'});
		} else this.$emit('checkStep', this.$options.name);
	},
	mounted : function() {
		let componentName = this.$options.name, index = this.templateIndex;
		let key = componentName + '_' + index;
		if(this.currentSession.stepsResults && this.currentSession.stepsResults[key]) {
			Object.keys(this.currentSession.stepsResults[key]).forEach( k => {
				if(typeof(this[k]) != 'undefined') this[k] = this.currentSession.stepsResults[key][k];
			});
		}
	},
	getLabel : function(label) {
		if(!label) return '';
		if(typeof(label) == 'string') return label;
		else if(typeof(label) == 'object' && label[this.lang]) return label[this.lang];
		return '';
	}
};



// WEBPACK FOOTER //
// ./src/libs/componentTools.js